export default __webpack_public_path__ + "static/media/meal-dinner-icon.2e89aa73.svg";